// extracted by mini-css-extract-plugin
export default {"footer":"index_footer__DaHul","endFooter":"index_endFooter__nzsLJ","listItem":"index_listItem__SUf9H"};